import React, {Component} from "react";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import {formGroup, getTableConfig} from "../config";
import {defaultTableChange} from "../../../../modules/custom/customTable";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import MasterPromoModifying from "./masterPromoModifying";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import {ACTIVITY_TYPE, HttpStatus} from "../../../common/Constants";
import {flattenFormGroupObject} from "../../../common/mapper";
import {contructQueryParam, fetchDataAsync} from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import ErrorAction from "../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import SimpleInput from "../../../../modules/SimpleInput";

class MasterPromoTab extends Component {
    actionsColumn = [
        {
            name: "id",
            label: "Aksi",
            options: {
                customBodyRender: (val, tableMeta) => {
                    return (
                        <FlexView vAlignContent="center" style={{gap: 30}}>
                            <SimpleButton
                                category="action_button"
                                style={{backgroundColor: "transparent"}}
                                icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-lw fa-pencil-alt"/>}
                                onClick={() => this.handleModifyingVisibility(ACTIVITY_TYPE.UPDATE, tableMeta.rowIndex)}
                            />
                            <SimpleButton
                                category="action_button"
                                style={{backgroundColor: "transparent"}}
                                icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-copy"/>}
                                onClick={() => this.handleCopy(ACTIVITY_TYPE.COPY, tableMeta.rowIndex)}
                            />
                            <SimpleButton
                                category="action_button"
                                style={{backgroundColor: "transparent"}}
                                icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-trash"/>}
                                onClick={() => this.handleShowAlert(val, tableMeta)}
                            />
                            <SimpleButton
                                category="action_button"
                                style={{backgroundColor: "transparent"}}
                                icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-eye"/>}
                                onClick={() => this.handleModifyingVisibility(ACTIVITY_TYPE.VIEW, tableMeta.rowIndex)}
                            />
                        </FlexView>
                    )
                }
            }
        },
    ];

    constructor(props) {
        super(props);
        this.userId = localStorage.getItem("userId");
        this.state = {
            loading: false,
            dataTable: [],
            tableColumn: [],
            modifyingVisible: false,
            selectedData: null,
            deleteId: "",
            promoId: "",
            activityType: null,
            isFetch: false,
            pagination: {
                totalData: 0,
                limit: 5,
                page: 1,
            },
            keyword: null,
            promoName: null,
            alertCannotDelete: false,
            alert: {
                visible: false,
                content: null
            },
        }
    };

    componentDidMount = async () => {
        this.handleTriggerLoading();
        this.setState((prevValue) => ({
            ...prevValue,
            tableColumn: [...getTableConfig(this.props.tab), ...this.actionsColumn],
            keyword: null,
            promoName: null
        }))
        await this.fetchData();
        this.handleTriggerLoading();
    };

    componentDidUpdate = async (prevProps, prevState) => {
        if (
            (prevState.pagination.page !== this.state.pagination.page ||
                prevState.pagination.limit !== this.state.pagination.limit) &&
            !this.state.isFetch
        ) {
            this.handleTriggerLoading();
            await this.fetchData(this.state.pagination.page, this.state.pagination.limit);
            this.handleTriggerLoading();
        }
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: tableState.page + 1,
            },
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                page: 1,
                totalData: 0,
                limit: tableState.rowsPerPage,
            },
        }));
    };

    handleShowAlert = (id, data) => {
        if (id) {
            this.setState((prevValue) => ({...prevValue, deleteId: id, promoId: data.rowData[1]}));
        } else {
            this.setState((prevValue) => ({...prevValue, deleteId: "", promoId: ""}));
        }
    };

    handleModifyingVisibility = (at, id) => {
        this.setState((prevValue) => ({
            ...prevValue,
            activityType: at,
            modifyingVisible: !prevValue.modifyingVisible,
            selectedData: prevValue.dataTable[id],
        }));
    };

    handleSubmitModifying = async (controls) => {
        this.handleTriggerLoading();
        const formGroup = flattenFormGroupObject(controls);
        const req = {
            id: formGroup.id,
            promoId: formGroup.promoId,
            namaPromo: formGroup.promoName,
            startDatePromo: formGroup.startDate,
            endDatePromo: formGroup.endDate,
            gracePeriod: formGroup.gracePeriod,
            tipePromo: formGroup.promoType?.value,
            status: formGroup.status,
            cabangBerlaku: formGroup.applied,
            leasingId: formGroup.leasingId?.value,
            detailPromo: formGroup.dataUnit?.map((item) => ({
                idVariant: item.dataVariant?.kodeVariant,
                idWarna: item.dataWarna?.id,
                tahunProduksi: item.tahunProduksi,
                subsidiAhm: item.subsidiAhm,
                subsidiMd: item.subsidiMd,
                subsidiDealer: item.subsidiDealer,
                diskonMinimum: item.diskonMinimum,
                nominalLevel1: item.nominalLevel1,
                nominalLevel2: item.nominalLevel2,
                nominalLevel3: item.nominalLevel3,
                nominalLevel4: item.nominalLevel4,
                nominalLevel5: item.nominalLevel5,
                nominalLevel6: item.nominalLevel6,
                nominalLevel7: item.nominalLevel7,
                nominalLevel8: item.nominalLevel8,
                ...(formGroup.promoType?.value === "CREDIT") ? {
                    credit: {
                        dpAwal: item.dpAwal,
                        dpAkhir: item.dpAkhir,
                        tenorAwal: item.tenorAwal,
                        tenorAkhir: item.tenorAkhir,
                        jp1: item.jp1,
                        jp2: item.jp2,
                        jp3: item.jp3
                    }
                } : {}
            })),
            wilayah: formGroup.wilayah?.value || null,
            cabang: formGroup.cabang?.map((item) => item?.value),
            userId: this.userId,
        }
        try {
            const res = await Api.create("NAGAMAS_MASTER_DATA").saveAndUpdateMasterPromo(req);
            if (res.ok && res.data.status === HttpStatus.FAILED && res.data.code === 503) {
                if(res.data.message.startsWith("Terdapat kode varian")){
                    this.handleAlertVisibility(res.data.message);
                }else{
                    this.props.setError({
                        menuName: "Master Promo",
                        errorMessage: res.data.message,
                    });
                }
            }
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.handleModifyingVisibility();
                await this.fetchData(this.state.pagination.page, this.state.pagination.limit);
            }
            this.handleTriggerLoading();
        } catch (error) {
            this.handleTriggerLoading();
            this.props.setError({
                menuName: "Master Promo",
                errorMessage: "An unexpected error occurred.",
            });
        }

    }

    fetchData = async (page = 1, limit = 5) => {
        this.setState((prevValue) => ({
            ...prevValue,
            isFetch: true,
            pagination: {...prevValue.pagination, totalData: 0},
        }));
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getListMasterPromo,
            setError: this.props.setError,
            menuName: "Master Promo",
            args: {
                tipePromo: this.props.tab.toString().toUpperCase(),
                page: page,
                limit: limit,
                promoName: this.state.promoName || null,
            },
        })

        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.setState((prevState) => ({
                ...prevState,
                dataTable: res.data.data,
                pagination: {
                    ...prevState.pagination,
                    totalData: res.data.totalData,
                    page,
                    limit,
                },
            }))

        }
        this.setState((prevState) => ({...prevState, isFetch: false}));
    }

    handleCopy = (activityType, index) => {
        this.setState((prevValue) => ({
            ...prevValue,
            activityType: activityType,
            modifyingVisible: !prevValue.modifyingVisible,
            selectedData: index === undefined ? null : prevValue.dataTable[index],
        }));
    }

    handleShowAlertCannotDelete = () => {
      this.setState((prevValue) => ({...prevValue, alertCannotDelete: !prevValue.alertCannotDelete}));
    };

    handleDelete = async () => {
        this.handleTriggerLoading();
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").deleteMasterPromo,
            setError: this.props.setError,
            menuName: "Master Promo",
            args: contructQueryParam({id: this.state.deleteId}),
        })

        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleShowAlert();
            await this.fetchData(this.state.pagination.page, this.state.pagination.limit);
        }

        if (res.data.data === "Promo Has Been Used") {
            this.handleShowAlert();
            this.handleShowAlertCannotDelete();
        }

        this.handleTriggerLoading();
    }

    handleSearch = () => {
      this.setState(
        {
          promoName: this.state.keyword,
        },
        async () => {
          this.handleTriggerLoading();
          await this.fetchData(1, this.state.pagination.limit);
          this.handleTriggerLoading();
        },
      );
    };

    handleAlertVisibility = (content, type) => {
        this.setState((prevValue) => ({
            ...prevValue,
            alert: {
                visible: !prevValue.alert.visible,
                content: content,
            },
        }))
    }

    render() {
        return (
          <>
            <FlexView>
              <SimpleInput
                id="keyword"
                placeholder="Nama Promo"
                value={this.state.keyword}
                onChange={(e) => this.setState({keyword: e.target.value})}
              />
              <SimpleButton
                id="btn-search"
                text="Cari"
                onClick={() => this.handleSearch()}
              />
            </FlexView>
            <SimpleDataTable
              data={this.state.dataTable}
              columns={this.state.tableColumn}
              toCount={this.state.pagination.totalData}
              rowsPerPage={this.state.pagination.limit}
              page={this.state.pagination.page - 1}
              options={defaultTableChange(
                this.handleChangePage,
                this.handleRowsPerPage,
              )}
              footerAdditionalButtons={
                <>
                  <SimpleButton
                    icon={<i className="fa fa-plus margin-right-10px"></i>}
                    onClick={() =>
                      this.handleModifyingVisibility(ACTIVITY_TYPE.CREATE)
                    }
                  >
                    Tambah
                  </SimpleButton>
                </>
              }
            />
            {this.state.modifyingVisible && (
              <MasterPromoModifying
                {...this.props}
                userId={this.userId}
                formGroup={formGroup}
                initialValues={this.state.selectedData}
                visible={this.state.modifyingVisible}
                onSubmit={this.handleSubmitModifying}
                onClickClose={() => this.handleModifyingVisibility(null)}
                onDelete={() =>
                  this.handleShowAlert(this.state.selectedData?.promoId)
                }
                tab={this.props.tab}
                activityType={this.state.activityType}
              />
            )}
            {
                this.state.alert.visible && (
                    <SimpleAlert
                        title="Information"
                        visible={this.state.alert?.visible}
                        onClickClose={() => this.handleAlertVisibility()}
                        content={this.state.alert?.content}
                        additionalButtons={
                            <SimpleButton
                               text="OK"
                               onClick={() => {
                                 this.handleAlertVisibility();
                               }}
                             />
                        }
                    />
                )
            }
            {this.state.deleteId !== "" && (
              <SimpleAlert
                title="Information"
                visible={this.state.deleteId !== ""}
                onClickClose={() => this.handleShowAlert()}
                content={
                  <div>
                    <p>
                      Apakah anda yakin ingin menghapus data{" "}
                      {this.state.promoId} ?
                    </p>
                  </div>
                }
                additionalButtons={
                  <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                    <SimpleButton
                      text="Batal"
                      onClick={() => this.handleShowAlert()}
                    />
                    <SimpleButton text="Iya" onClick={this.handleDelete} />
                  </FlexView>
                }
              />
            )}
            {this.state.alertCannotDelete && (
              <SimpleAlert
                visible={this.state.alertCannotDelete}
                onClickClose={() => this.handleShowAlertCannotDelete()}
                content={
                  <div>
                      <p>Data tidak dapat dihapus, sudah masuk kedalam transaksi.</p>
                  </div>
              }
              additionalButtons={
                  <FlexView vAlignContent="center" style={{gap: "10px"}}>
                      <SimpleButton onClick={() => this.handleShowAlertCannotDelete()}>
                          OK
                      </SimpleButton>
                  </FlexView>
              }/>
             )}

            {this.state.loading && (
              <SimpleLoadingOverlay active={this.state.loading} />
            )}
          </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(withFormGroup(MasterPromoTab));